import React from "react";
import style from "./profil.module.css";
const Profil = () => {
  const profil = [
    {
      profil: "Kegiatan",
      style: {
        backgroundImage: "url(/img/profil_1.jpg)",
      },
    },
    {
      profil: "Formatur",
      style: {
        backgroundImage: "url(/img/profil_2.jpg)",
      },
    },
    {
      profil: "Sejarah Ipm",
      style: {
        backgroundImage: "url(/img/profil_3.png)",
      },
    },
  ];
  return (
    <div className={`${"profil"} ${style.profil}`}>
      <div className={style.title}>
        <h1>Profil</h1>
      </div>
      <div className={style.container_card}>
        {profil.map((profil) => (
          <div className={style.card} style={profil.style} key={Math.random()}>
            <div className={style.title}>{profil.profil}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Profil;
